import { render, staticRenderFns } from "./lrAIChatList.vue?vue&type=template&id=9fbe3816&"
import script from "./lrAIChatList.vue?vue&type=script&lang=js&"
export * from "./lrAIChatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports